import { render, staticRenderFns } from "./pjnoticeIndex.vue?vue&type=template&id=f361981e&"
import script from "./pjnoticeIndex.vue?vue&type=script&lang=js&"
export * from "./pjnoticeIndex.vue?vue&type=script&lang=js&"
import style0 from "./pjnoticeIndex.vue?vue&type=style&index=0&id=f361981e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports